import React, { useContext } from 'react';
import ReactHtmlParser from 'react-html-parser';
import Truncate from 'react-truncate';
import styled from 'styled-components';
import { SearchFieldContext } from 'components/SearchFieldContext';
import TextHighlighter from 'components/TextHighlighter';

import SearchResultLink from './components/SearchResultLink';
import SearchResultImage from './components/SearchResultImage';
import TitleContainer from './components/TitleContainer';
import DescriptionContainer from './components/DescriptionContainer';
import InfoContainer from './components/InfoContainer';

const TierLabel = styled.p`
  margin-bottom: 0;
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  /* or 117% */
  letter-spacing: -0.408px;
  color: #484848;
`;

const GenericSearchResultItem = ({
  id,
  name,
  logo,
  description,
  tier,
  variant,
  to,
}: {
  to: string;
  name: string;
  logo: string;
  tier: any;
  id: string;
  description: string;
  variant: 'compact' | 'standard';
}) => {
  const { searchKeyword } = useContext(SearchFieldContext);

  return (
    <SearchResultLink to={to} variant={variant} key={id}>
      {logo && <SearchResultImage src={logo} variant={variant} />}
      <InfoContainer>
        <TitleContainer>
          <TextHighlighter
            searchWords={[searchKeyword]}
            textToHighlight={name}
          />
          {!!tier && <TierLabel>{tier}</TierLabel>}
        </TitleContainer>
        <DescriptionContainer>
          <Truncate lines={1} ellipsis="...">
            {ReactHtmlParser(description)}
          </Truncate>
        </DescriptionContainer>
      </InfoContainer>
    </SearchResultLink>
  );
};

export default GenericSearchResultItem;
